export default __webpack_public_path__ + "media/images/portfolio/gallery-05-1200x804_original-11f54c6afb2f272ae7833e1e0f1f46fe.jpg";